import * as React from "react";
import { getTwoDecimalTrunc } from "./Address";
import { DataTable } from "../ui";

export function AssetTable({ assets }: { assets: any[] }) {
  const rows = (assets || [])
    .map((asset) => {
      const name = asset.assetName;
      const balance = asset.balance / 100000000;
      if (balance === 0) return null;
      return [
        <a href={"index.html?route=ASSET&name=" + encodeURIComponent(name)}>{name}</a>,
        getTwoDecimalTrunc(balance).toLocaleString(),
      ];
    })
    .filter(Boolean) as React.ReactNode[][];

  if (!rows.length) return <span className="dim">No assets</span>;
  return <DataTable headers={["Asset", "Amount"]} rows={rows} />;
}
